var classList = require('dom-classlist');
var gsap = require('gsap');
var pubsub = require('pubsub');
var serialize = require('form-serialize');
var xhr = require('xhr');
var ScrollTo = require('partials/scroll-to');


module.exports = function (el, blocT) {
	var _form = el
	,	_inputs = _form.querySelectorAll('input[type="text"], input[type="email"], input[type="radio"], input[type="file"], textarea, select')

	,	_confirmField = _form.querySelector('.confirm')

	,	_btSubmit = _form.querySelector('.bt.send')

	,	_btPrev = blocT.querySelector('.bt.prev')
	,	method = _form.method
	,	action = _form.action
	,	to
	,	isLoading = false;



	// --------------------------------------------------------------------------------------------
	// HANDLERS
	addHandlers()
	function addHandlers() {
        _btSubmit.addEventListener('click', clickSubmit);
	}

	/**
	 * Send newsletter form
	 */
	function clickSubmit(e) {
		e.preventDefault();
		//submitForm();
		grecaptcha.execute();
	}

	/**
	 * only for newsletter subscribe
	 */
	window.submitForm = function() {
        if(isLoading) return;
		isLoading = true;

		classList(_confirmField).remove('active')
		Array.prototype.forEach.call(_inputs, function(input){
			classList(input).remove('error')
		})

		var reqContent = serialize(_form);

		reqContent += '&infos='+_form.querySelector('input[name="infos"]').value;

		xhr({
			url: action
		,   headers:{"Content-Type": "application/x-www-form-urlencoded"}
		,   method:method 
		,   body: reqContent
		}
		,   function (err, resp, body) {
				if(err == null){
					manageJson(body);
					grecaptcha.reset();
				} else {
					console.log(err);
					grecaptcha.reset();
				}
			}
		)
	}

	/**
	 *
	 */
	function manageJson(body){
		isLoading = false;
		var JSONbody = JSON.parse(body);

		Array.prototype.forEach.call(JSONbody, function(el, i) {
			if(el.level == 'error') {
				// ADD CLASS ERROR
				switch(el.field) {
					default:
						classList(_form.querySelector('input[name='+el.field+']')).add('error');
						
					break;
				}
			} else {
				Array.prototype.forEach.call(_form.querySelectorAll('input'), function(el, i){
					el.style.display = 'none';
				});
				blocT.querySelector('p.confirm').innerHTML = el.msg;
			}
		});
	}
}
